export const FETCH_COMPANIES = 'crm/companies/FETCH_COMPANIES'
export const FETCH_COMPANIES_FAILED = 'crm/companies/FETCH_COMPANIES_FAILED'
export const FETCH_COMPANIES_STARTED = 'crm/companies/FETCH_COMPANIES_STARTED'
export const FETCH_COMPANIES_SUCCESS = 'crm/companies/FETCH_COMPANIES_SUCCESS'

export const PAGE_COMPANIES = 'crm/companies/PAGE_COMPANIES'
export const SEARCH_COMPANIES = 'crm/companies/SEARCH_COMPANIES'
export const SORT_COMPANIES = 'crm/companies/SORT_COMPANIES'
